import { HTTP } from "@/helpers/http-common"

const url = "/api/substatus"

const get = (data) => new Promise((resolve, reject) => {
  HTTP.get(`${url}/${data}`
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const list = (data) => new Promise((resolve, reject) => {
  HTTP.post(`${url}/list`, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const save = (data) => new Promise((resolve, reject) => {
  HTTP.post(url, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const update = (data) => new Promise((resolve, reject) => {
  HTTP.put(url, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const disable = (data) => new Promise((resolve, reject) => {
  const { clave } = data;
  HTTP.delete(url, { params: { clave } }).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error.response);
  });
});

export default {
  get
  , list
  , save
  , update
  , disable
}



// WEBPACK FOOTER //
// ./src/services/operativos/substatus/index.js